import request from "@/utils/request";
import CryptoJS from 'crypto-js'
import { decryptByDES,encryptByDES } from "@/utils/3DES";
import useIaaStore from '@/store/modules/iaaParams'
import { ElMessage } from 'element-plus'
import VConsole from 'vconsole'

export default {
	sdkPostMsg: function(params){
		if(useIaaStore().isTest == 1){
			console.log('web端测试======')
			if(params.action === 'webDidLoad'){
				// console.log('web端初始化测试======')
				let args = {
					"openId":"65372976",
					"deviceId":"REL",
					"nowTime":"1766564826864",
					"osType":"1",
					"modelName":"PD2429",
					"devTools":"ads",
					"versionCode":"1.3.5",
					"gameId":"2343",
					"ScretKeys":"b43f2836cab85d8a690e2078239c36e6",
					"packageName":"com.dhc.gm.qipa",
					"serverId":"10101",
					"serverName":"测试1服",
					"chanleNo":"1",
					"roleId":"83815954",
					"roleName":"芽生5勇敢",
					"level":"1",
					"extendParams":''
				}
				args.extendParams = JSON.stringify({
					super_user_id: "65372976",
					super_token: '',
					game_id: '2343',
					channel_id: '1',
					super_role_id: '83815954',
					cp_role_id: '24062027256947',
					service_id: '10101',
					service_name: '测试1服',
					role_name: '芽生5勇敢',
					role_level: '1'
				})
				console.log(args)
				let secrets = encryptByDES(JSON.stringify(args))
				// console.log(secrets)
				// let secrets = "jTspipVJ7lNsFw9HOWcwdjkfwqNaWxV//lZ/EJfJavacBor39gXiLCr2aBEpnk9LkzgibbYyYT4PF51Bh4rN9EN8d/snsI7jAiMASbvWcScL7gEW/MopdFoYdQXQuFHX8f7T4AFuDSqdAEmgXwcRdlYX/4BOCmg3InJD9m2CnrP0RLUyBhv7pxGWP0wh5/DsVUBlGODzsxhbGR2SXzQOferC8Pz7wtfgqYhFYqO7MfnoMDt2Hbi1A2PsMUi2xTK8Mn5umtRiyjrqIG1dugIsWYXnJDBs2Z3KTfBEVOYUkR0OOVUpJYkqK4kgJ/64y/GBaxlrnGPoPX5jmw/O5bn/Ys80iFrBoDgwM3inzv4y9iw3PemcQBD4OCSvnUdV93AShb4Qx/xF8h927iydq3bvvCMTbGXvb8gZ9hJXoxCPudvSxklqxVGR6LYs0zNWuIGrV2qJWgfDyco/4a+83awfsuXRqX9QyjpHfm5EOWBt1vtDXuUVdsuZjHboysNv77ZFc1Ts/QEON4NlEGfHPgiBWULdal6W8iEoltmX7Wd1fkhWgDNQyKIzPfMpiu0Ssv9MxAKD7kQsjS4e12twtKbG0QAWmvh6UUwKGb9gk7CgWhP28BWadjKYSWDitwEaScMYvlpz/IZHL+aAg5mPdF90cSglBkpaoygIE3NKKyPHJVngl/XG5Yy2b/2DCbGQKSooT7QhWj5G1afyMq3QnzFTytPk+k5ySG+5LDyIko+iOSaOfnk3mf95eBzkJhiwTdBHL5Rwz0G5R9STx0Xh7jm2Sy9gsV49Y9vSLBk95kfP06CFMPtU249xS2ToYa8PUbPZ1d+PXRfdCHwHZk0H8FZkkep5ogVgVFHDCv5F9GyNZrUaQJ+Ug86ILT7ZogtyPi7WVHWrXZnFw0LDmg1ZOSLFwN58si5xcQfXrGS1lwvuYOJjJoEfkNVhdUiJrT2dkNDMF7gNa33xEJcbxaOHaUaq4PorRp3ODTowxIACf8MtbCdsEFIxOvMXlBimJ7oMEYSK3b0P8BBvKA92SThbhjha6qS6lHRtWFvyyl5JqdvJG9Cck0VUTbtvY1UVdvHwxarQPqtfNdkGXnOddBOTkd7fIA=="
				// let secrets = "jTspipVJ7lM8wTQn9hGWjicQ9PjhlVggL1wE72oYUZb0xraC5jcOgm+ZX6laUenuFgK8VYqBKppBGiEtPqq/ZzExCC+zCmmRWD2ktzgiq9lHsg2N0yvN197HDyz6W/M/ylrSXxRD8GlbwIhgyaJIJefdkLqWAI3xu4QIiJKOYbwDpw4/GbYAw7SOVuONN7lMMxKqjTMa+e04mOk5zOEmus2gElRlgJGKgFYZuVMfioPISMaK05i4K2m6TxzsfSpZRWfSREkdbynyV84CphOnWu4L2Brrm6AK/LgSagfgpE7KyepyfO97YBiEd284a2xhirUhOqDoGs28mNYLDO0J/XlFdybUtQJx1riGdU6qDF8J1yYIt1SyaJHl+hRo6WICE3JhBdFa6qgYsgpH5cJracpUzL0GZnT4r/wAUbUaysV1gU4ZTwkPDGJucwqPZEqbIzF3BdbFS/aRAhFWqirTgFdi5ghLvGQydb8Z9qG9VoGgYSqpkt5BpgIg6w0VmK/dSr9kaMHwFB3Qwzy9iTUdiuMYwG9tKcepgTxS7/qOuIt33EDkKtBbOurASpqi7TSnPukb80TfBlmFhHheC8fQSkbeAMGVex6wGSYp1UHdUQlU1mXl4Nbr4EVToqmBXznwHmaO29Gci2JJuJtMkg53HHmXIVzCV3dJsLCR5/1Ac4ifoqciB5EE5H7aZRWa+25Mxqv3Wyqr0jv6LY/sX4PI8CBlc2kDcLQ37Cew4M0rCtSjchyIB60q46rs36ZJ8vFgsewWr7kS1cDEGjJmMlUO2EG6lzr60xcldKE4EdziREoTb32xWcLR4p2Pv/IoxkVFwTkG8nBD1ToHhDas+3ZpYqFd6HN5MrZ+ih0Lor/Xe5tWSCuwq/a0S5kK3jZAotb3XJZmHt31iOOU/gK+vtU3kZFPCZWvzoA/5UKk3aRS0CvhL44FEZIvgD6zSI/Oeq58gfBD0xhv8J3C+X4vMcE7ttZuE6AkyCId8qh14VTRe4Lk7vzFi14LnHIMruJ9MuhKXnNjHUE2DD2QjyMX/IwxEgLNf6Xg2XM+k7LFN7OhOgb1t26qGQMvQVDCNoo3tsvbfHb9WpwUW3wFRzXMfDOsdw=="
				// let secrets = "jTspipVJ7lPw/fXsflkCsHAXtf6jjoq7E4hrRzIohiPEzOiBixy+dzD1Rbw6AMwPPaqv9G8RvW4fbNKJbgabjIjkPSJuqfxclPnqtvO7AtO+bA3WzKS3LG4+4EKCJwj0cRwMlhH84FjUBN2AMBpCsjanwDd6hAx6fKOhOthzvE0Zm3RkjZvvE5N8sMSH95fPynqLbYbCIScFpd6LIAYevheR7JHoi4oBfsXCCXXMbAVz76KeVa4seD7LqxicTa/uGhQhkQho2BP9/ce6v5nmrVH02P/gok3+7QMZq8flYllUYmBUwYHLpNGSMcOICEGtr3atz+jrL4itboAY0ktj1uY3LjqC1JnXQxhpubmyOAbH7fVxjZNiFoQP/SSds/svgCky5OEcSniRBPn306zl6Scglh1nzFnAP5dYENWnDbX2i3qcIMe+i1tSB270Gdw7JUWRSjw9WdQ4afhGyPPy8S0rd2lIcc4XK0fKj891EtILdO7Xj9LexyPfWz7n0egOba2gCJslp066UJ34jE0YfLuWyFSpaUJRFlfF3VC0YI8MGYxod4cTIB3JKHKxdjaOkdiySd647j/mBGNSYciUP+oZgwG7zrclIvbp3iJLBi0SpQxu78TUBpGAfI8BU6pYA+B1wJdFweKSH1Q9hw0Licxg1h1SR/OICjPy5PpxLrgTu8gvMev1jkgihi/MZZgFtAo4jLr1YqQ6BT/f7qeIf3DfpOyHU6YDGcc75SsxMQQM/xdnKfqkSnWSI/tNw0odphD8x74HKqlhDRG2AMol3cz/t4RmUUAzgiclxqK3xgZ9dVXEi4eEQ5Hc9O4c23+TReg8WwITrr85ELerSt8HdX6AQLdM/PYvTw5DzTjlwJRm+LebSYCijIiuhQ8zbVMS7fqjK7fky/VqpGmH7tuMjkK5oNeBYnC2Dfo8W92euDCttopAOxcyWRNSPeOe6xQKTizviVp0Y10+sNs0a54TWCwZ/IncuXJzv/oIcp77G4+bHAca2w4N5xeYEaG9bGqFhTnlq6E/DAEKZbLZXWSLbxP22vA5UREKcTPwUt8ynnrACKuw+w0MZqXsoFg+8atyZOYdq37+4+33SguWd6seog=="
				// let secrets = "fxHxLgwMIItmZ/ACi6Iq0wQJ3ZzG5pPE+gZ99GjegIXOE/G3rOb2yD2pAcZYDiKpV4Uz1H+w/i7X6uK1E7uvzgihpMEwrI4yK+swxQHNNphqGlT9/0JJRaFWieNPd9bsMigj9ekb6ihlhMDh/g9H6tWqtOvpwXSsM9rCb64do6gbP6M5GRNDZP/FQSB7w2GK1LLGtbKdAnokbb2q983HuQZGs6MfaWc3DwsqvtJJj0E2c1tGBQHYEEQRubFf7DDRPVhpWFKH/LMEe750fVYi42DAKNPALsSjAjfeefQaIFdkWfcbdmPvYcZPXWYHStXzbggeLE+qBOGt8s4tPMQp1gIjwB4DjMYJnkxDrLFRxSKsOb41SF5Eo8LiTvsV/QRCRtHm2kxRtQm/oJfvCkl4Sinm+3ClMr1tirWpn6JNLbenjAa3xwVeWp6UlSJjtaOOudeW1ExIs42jaiOVpnR7VU8jcFvgv3RZsrD8h5pcTnYTV4Z5qQAFKw=="
				// let secrets = "jTspipVJ7lPRMLGcetpGA9jHpbMumq8OSi6Kzi7Rpmlyt5Qha2O4wC7FCsQsbaf7qlvYAU75KWayJKy3UWULq6OmigfgemnUyDB/jr1XZCtcxqCReQdsbmeAXRS8iMKzVzrVICjktJ8btsa0OwUjwohnAhCjL6knxL1CI1o0vpiLbrfCRzRGGI3qxfrB7uuBa9NMCZP6JamhpIaSyTA5f2S8YexyEjaK5hOQkbPJlIWz2jPxz0HmAclwPUJcICitfGCuIHs6hwIFRUOcc29HX1NU6zTWnbCHiimJ30nMh1WwswdgA336NUWGhP69L2IGV1NdZxv4R/rhl0Z8zO4CheThfg1TPYKfTtY3XFBjzbKcUdR43wf8MPPfYndSGV76CJsqUCOyLWX91b+E/5oGt9Kj68rGEGda71OW0kxZ61fRICZuiDTGZrXYcEWO89sw56Q17CL+uv2hrzxhQgn53YdOPjGlhZr46rIqBGpJ88w6ja0KXpQ/GIz2TVzRWBJ2c4JHLPlxKcqK713YWz6GvuZyWV4bRKrwxxJmBqBO3vlKxFhZqnaG1+pWCtCLj0fuGiyOP2TCbhpRW8bKyfCnCb53DhYI64Y5nBjeL1wWABtsmNvlVsSytriH02x4+MhcypNc+Q7CW8/MzLfi9BZwwbJ/rXRlJWKwsKh8QmSUMGWTfCMW5xwp2XZwhRtUYv8fOjZWFiiIErvI75pONM6fMS4IM0UU4DCn/+4VcPkZbyxk3sxIuO84FTn6JYdIbaiakBrKQo0zhG1L68xpF80KiXHbg2e+REK0q0S3c++hWqCBxlKcaHJ4JNeWeHQBsCRzjLnBA4EDd3C07ttPnvxJT3GfbxDUmqszVjQXi94SAAMarY1ia3oAyvBcoCDOe7AydaBR4CDJvmVvtKfyiK2lB6HyQZKVae4M50nwznIkgUy16R9nEsOgF/JfQIO/L4nspVYAM53qW6Nnd5DMBD0Ub3I+ZLz1qlS85IKQ5S8cboNeKL8OqFubByFitbzi64z7o7s6ss9TQyz+Hn4E2ikw4v5wFEg3lkETaQptSY1nZILtqGEVThbGTqactw12BOax"
				// let secrets = "fxHxLgwMIIu7GMR/t5u5rSAMv1kq11Psg7EA07VOfYXtYyvJ1RQ+0sXsjCACGi0wTca/AQKX7V3jB+bJT1rzMCtAMMA+P01uyONXyzR18RCSj2QEDYBqnvCQ3l+T38NG4D1iQhYSCZ1l9DuuZKddVLSxurcnESOy3L454ifecgSJR/HoQVEIwpPxWiGDRJ2sNWsZLjOA5FJS2wtts4SKA1vhxmFc8FEciR7DBiBco092PBZqSyV2CwTsaBtX0deBsg1x7ckbC6Uqy77ga1FFx9BsrWi9gtNtFBQ+476uodT6srJtmZua4TQ6NpUv0anh/dh/9uoiRbNF5FSWnElg3r3RtZZVRCxWdRAhJhTEzFpUc3ueB4ZTp/PbLTSQ+AZDbgQHaPqv+1Z61G2Ls4ojMREhAmWyP/RbYzekeKjx26pD7QQIH2Cc/uZfZnfnkGxXlETGfBBKpVoBj4DUCia6iwjfGxVUo3dm"
				// let secrets = "jTspipVJ7lP9a6S0yN0Q2Efe2umSoAqSKVgHs7rEvnCktfUhA9CDPvSeMXDb9uQ0wpalGFIbHjm6vnft8ERtXnGisElhaWG+52XjVxRp7p5FbWjM+mkY9yz9BZeAb8/rghSwBovRfLvfTKSQ0axsHwzET3cN40q7uSZbFUdAvy8JDs4CaV2kQeKh8rgmbLOwGUYH319viXygrGinu19KfOdXZsCOzhu5wvYtDFgiqDeD3JCPByeoQuEukw/PK17u9cShnMti/IHZTplftuvOTaozXyNHtbM/7AwYucnZOr2NBQ6IpR5ZOkpiLtbPZehpCPtW2pqOmsmr6LuLYXQ7pSwNjFHH1zDdn48habEilAG/FN/jrzm4VDFvaS4jq3AVf21ykA7q/1LUbTOIA3Ci0ua832+bVukMuYuUDn5ftxDnH53PDIPXfshB88uJmOBN6AaMVOJwPlJHnCNaGHCE5ONF1E1PNPEhOV8XMWB6xQhDKvWHY4P3dw7XDlT+7o+/2GaPEF6pbv94go9rLnEBzraau58i+GGvxPzK27LTk9abdDEt5wFKYc9rRePXbEu076g/iJ02agX7J4+YvgYDJocaYgj1jvAta0sAloaZauP6FEQeIPmTB7sRRQcyNyv9gNPShAI1J9KrmpWOKZpszPyE9ReSffh+GEyAe///z7eopdg5bmy+/5KmZsxQ2CdcmU3sxTtjP8DNOMpdmqbvWS57QUg/lQ6H5M+ydESk8sbxolFOspUC9TNAcVnkblhwWTgvYiU+KBvXTdc+jygP5jAQF8Br8Q8/G/LkvftO4Heo8V2ILYAdm5jxmuiCo46enk/1VFdcN9Rru3dxaFsIG5Bt7rKkIixI+8XViDIk5sAz1vsMX6LZqbaJv6Rnn5cbJHgEabS+hNj2BI3iISnyypIJ7an7m6h/Y8AiM43Ir91utWAYAzvvMcLkrwqmMMAElMrk4VKlcYOdKc3r0X9ptRvm1uKiXurYqSOmynjBs5el07yvb1KD5L8SulfOTKZwYDvyJ64nHVIMJhL+ErVDD8kVr5BNzbJbPuExCK3iiwzXLG6KdikowtTg8xgnNwE5WdVINEsULkSi2uwtNnj0PA=="
				// let secrets = "jTspipVJ7lNFe+GgK2itZddesz4R05fEkhea1vujSXsorza86IwpEjvm6Gae9DffZDKd1Jva7AwaV4ZjepDDQjVGPl62A7+vWS1RArC3t8rBftrB/yWUXKW7r3/Dviy0I1vDiPgMe0R1FeIocPttHd+PwowKJ3gY00wBXN48vbQJkk8r4QK3UvjapW0QWRPSOvz8pxaLFvDf//8SorR0ilMnR6tHmBT7ik0t6808m4pkx4K6OirX0ezDp57ta2yV4f2UahYpSIVnXil2qe/GE1SmcXrH32K5/+otu7TV2eyKVOEFS1hSoPsRCfwCgtgVALIo5ZH3sMn0R8E97v4CNHHMUhk/MJctWUBPhVwXoIU1pCWjBQFBEZ7PTkAK5BoZywS+5augHm+/V7oW1nH8hNoTrqGGofWvLd/YIZVgo3F8SU0bX66CJS+AGIVzAGw3KPmLBJ1L/6jg6A2LQOD+uyYSS7yd5+30ZK5BlE8wss3gC518/ikOJkqtV5yIn4y8Bh5/FfNmRy66gJQXPFbTRzY8jzqtqGPnt8mcU4x9+DdgoV5uwhHavVh/NF2OCFDtByCMHufMGCNxga+y8ZR/JI68h9mqbwh5klNqqniFXRlL7piFwTJgcAefCQSm3TsiNIjsaTW8hS0kzg9n2UIXMY+f/DNFl06Us1TwyXf/5BfxDEs+Z8n9QHHbIR4kvjl1+cNov77FJzuaowLIT4GAWBtrrvLq1h/3e/2G4rPfzLchfgA3HD1tulXVpJWdYesZHUyHhA8gggCEO07lwE4AsbfQRrtOkC8Cijmqv9cveFTu+Xkaad9NCQi9GBRM177+rGeAlGcFQsrJ6MX88HgFqwwY8fcaZ7gBpQH3f2mohPwG69zoHLLzuk6z0tM1DNDWwHXKcCVpLCL6euTy7hUvzE5/vxoAkktW+al/b9A8Tg3cvTPj9E+LL2jRGdpzb3JBBDU3+3zR7/RqC0XHcNys42swu1JgoABBlDqDRKzSwQvskfEFCTLGnCik9RFHZ+CKCXbC1x0UbGRway1NCn9TDE1251UWrwstXlB6GgxPhRpO3NPCNTYrbQ=="
				// let secrets = "fxHxLgwMIIu7GMR/t5u5rSAMv1kq11Psg7EA07VOfYXtYyvJ1RQ+0sXsjCACGi0wTca/AQKX7V3jB+bJT1rzMCtAMMA+P01uyONXyzR18RCSj2QEDYBqnvCQ3l+T38NG4D1iQhYSCZ1l9DuuZKddVLSxurcnESOy3L454ifecgSJR/HoQVEIwpPxWiGDRJ2sNWsZLjOA5FJS2wtts4SKA1vhxmFc8FEciR7DBiBco092PBZqSyV2C8L0kzdD2Yun3/jUfqvi+SVWl07OlJMMTm+96kosBWCb083Rc62dIKNoOSLbXYpFeV9o3p10teAafPtCNYlX9OAj8rzpAaXt+4e4Dc+FFR9rgRuBSdVfYmvWYU8IELmTd8pRwCHhM2bnA75FHylGDkhNXRqXv2PvEWqJZMOCRQ9+ok5e4/yWjEhs1bHIqnn0HsVsPoQKvw+uymXnE0wfDO81i3Yc3nvhTWXQsWoPHDu+jhOJuS4ME1HfoWDZNKfuzA=="
				// let secrets = "fxHxLgwMIIu7GMR/t5u5rSAMv1kq11Psg7EA07VOfYXtYyvJ1RQ+0sXsjCACGi0wTca/AQKX7V3jB+bJT1rzMCtAMMA+P01uyONXyzR18RCSj2QEDYBqnvCQ3l+T38NG4D1iQhYSCZ1l9DuuZKddVLSxurcnESOy3L454ifecgSJR/HoQVEIwpPxWiGDRJ2sNWsZLjOA5FJS2wtts4SKA1vhxmFc8FEciR7DBiBco092PBZqSyV2Cye9lB9fJwv9cHysigR/5NYt3p6asLVmGJh13aAPg8ISr39/37l+Qg7uPXl1c/lbBi53LZuZOkg7xhM+Lub294ki4ouFu+jSlkd6vqRv3UOHITjP5jP+V5fmGaTcTPj8BE0qs+9lVMJNrOT20ic12EFU8EuJ4x75je/Dk7E1Q+ErlMXZxOB5lNxN3e11bi/mdHIlB1wk0v4MU1Bi5BYfSME98kZGkBNDys68QRuza3hjQ6d7jaFR0h0="
				// let secrets = "fxHxLgwMIIu7GMR/t5u5rSAMv1kq11Psg7EA07VOfYXtYyvJ1RQ+0sXsjCACGi0wTca/AQKX7V3jB+bJT1rzMCtAMMA+P01uyONXyzR18RCSj2QEDYBqnvCQ3l+T38NG4D1iQhYSCZ1l9DuuZKddVLSxurcnESOy3L454ifecgSJR/HoQVEIwpPxWiGDRJ2sNWsZLjOA5FJS2wtts4SKA1vhxmFc8FEciR7DBiBco092PBZqSyV2C4fev+Ry3MAdmbfbzPqI/KwpsL6ipkw9DVInf54++zbqaQIzm7+eJWfuuzX/XDJsd3XrlRQ9Bc1olvfroxdQY+yKKrXlR9j34ZUJyATlw8QTM/yU4m13McoOmUBdOntXp09KJG7TPr+zPaRy+85QZowLQU7hPYF7URzrQJTZPvODFzO4LsM6Z5XeiYthuZEwm12ezx15FvOpQGOILxYWADeBR1+F00Bzf7XQTtv8NVU8scxfcm9mMeMKBGS8J7ZtGQ=="
				// let secrets = "a7paA3+Ag4OUuHq13hAfpaONQQb41x3wK6xKTvusZyBKHDEh1qw+O1IUp+EMoH34T8IE5RkIo/7WZFu+VD2TwF0DKRWbQjVElqv8h7zuhbB6zmsJF6DOredl1JSstrXEqI1McTET69fK8TQLhmhRmPGisnqe2dEzKRU+d7vBterMalWl7Y9YuWS5NWJgKRDk00MVCjpq8wSOkuUFyDal3J9qdunhQVj53ylyPIZSB/moTwYm/d8XqawekHuypUIdxvJb2QahffpTna40mxfpscszmvZAv7yO20g94RDIFcHrwjOy0nQfpByRIAHKSjZjzIciIvbfJaoHfC07cOsHGMMrz2kAzaMpkVSHcjdPo8vN1WvTNhlHO0DOT/eKDmVlcjAyEu5KYYk9ArxYFZ4eSamBo5BUBmddchY5S8cubJ8Jl0D9hHPVFk04oEW1cvU1OIEZoJBxxRfqewDl3hsfyGSOnHH21DZx4hB+JC5JPcW1oN9P0QzU8uTWHTTs4yXKOOeEkXvDHn3KjA70Qoi31odxhWvRZIynTh/dsV81XRfXTLxc1SYeK+VAY0VRfgUdEmLKyVxr4m0KTvdOn7WLfkuTtYz+e3FCZkOreYsqMPxeSvJtaIE6ra7lwXNowiX9KarnrtOvzuIfcWqlr1aE+yhPXH5KCLP/Y7PeMNUuiytN/dUoADGiq5c0ShfYE+plBEFWgGcZXdNoG7o5umTueOPB4TFMLZh6xsFbwA0N3TcSuKKIb6nN7Z2oTU0+avJIRequffgUFKjdcWZKw1U9uKhYVBUsRSbWygMqFFx2YvBZoe2iN8Xm413RIYOuffMMyhs/P2X47flOijVQBjObCYXD3MuUNW2csLGQzZPUDVDwaEynLdPGzb1fyQAfbwam5dhNZclHOr6rp1oCRSRPrMrsxU8AixMVCcy/fUJOhCMicRN/6ixs+JpD1kKUI4Fs"
				// let secrets = 'jTspipVJ7lOQd/H7Z2bIutKcvcPJUC9QlSC2LlfhjA5V9WhQNoNwLJ4Pk5GKFj02YnktHaWwsJOWUyLswuTI9RrH1hJ5XXERudLJ5+udVFB1iO8It5FS7UwB+JPdzlaiOMEbDwyEC/H130evEmEnD5U+kminn7IaEQ+OHATvRwI/MQePwjsMWefBA8Sv0azw2BuavCg+G/WqLCBFovS50vM4p7SA16GXDH4Ip5iKrsLhAJkI/3UPuVt34/IjZrw2G1pSk1HtZo2Akxxl/V9WXVKs2aUhV5vUHzMmsi5GPabm3IOkhFpl/s+E7NyFXa1znXrwC4jvjpHPXenlMWfgHltaU5WUp7XcwBtnOe/h44dsIa83L7SSVg=='
				useIaaStore().setSecretParams(secrets)
			}else{
				console.log('调用web端:'+JSON.stringify(params))
			}
		}else{
			var u = navigator.userAgent;
			var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			if(isIos){
				console.log('调用苹果端:'+JSON.stringify(params))
				iaaIosPostMsg(params)
			}else if(isAndroid){
				console.log('调用安卓端:'+JSON.stringify(params))
				iaaAndroidPostMsg(params)
			}
		}
	},
	sdkDialogInfo: function(dialogCallback,errCallback){
		let args = getparams()
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/user/viewInfo',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				dialogCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkDialogRewardInfo: function(dialogCallback,errCallback){
		let args = getparams()
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/turntableConfig/getInfo',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				dialogCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmDialogRewardInfo: function(dialogCallback,errCallback){
		let args = getparams(false,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		if(!args.roleId){
			console.log('角色信息异常')
			return false
		}
		request({
			url: '/platTurntableConfig/viewInfo',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				dialogCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	// sdkHzRewardInfo: function(dialogCallback,errCallback){
	// 	let args = getparams(false,{},true)
	// 	let sign = getSign(args)
	// 	delete args.ScretKeys
	// 	request({
	// 		url: '/seasonAwardRecord/getCreateRoleSendAward',
	// 		headers: {
	// 		  isIaaApi: true
	// 		},
	// 		method: 'get',
	// 		data: { sign, ...args }
	// 	}).then(function (res) {
	// 		if(res.code == 200){
	// 			dialogCallback(res.data)
	// 		}else{
	// 			errCallback(res)
	// 			ElMessage({
	// 			    message: res.msg,
	// 			    type: 'error',
	// 				plain: true
	// 			})
	// 		}
	// 	})
	// },
	// sdkHzRewardDeliver: function(dialogCallback,errCallback){
	// 	let args = getparams(false,{},true)
	// 	let sign = getSign(args)
	// 	delete args.ScretKeys
	// 	request({
	// 		url: '/seasonAwardRecord/deliverUserSeasonAward',
	// 		headers: {
	// 		  isIaaApi: true
	// 		},
	// 		method: 'get',
	// 		data: { sign, ...args }
	// 	}).then(function (res) {
	// 		if(res.code == 200){
	// 			dialogCallback(res.data)
	// 		}else{
	// 			errCallback(res)
	// 			ElMessage({
	// 			    message: res.msg,
	// 			    type: 'error',
	// 				plain: true
	// 			})
	// 		}
	// 	})
	// },
	// 是否接入iaa
	sdkIaaGame: function(id,getIaaGameCallback){
		let args = getparams()
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/platTurntableConfig/iaaGame/${id}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getIaaGameCallback(res.data)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkRewardGetKeys: function(id,getKeysCallback){
		let args = getparams()
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/turntableConfig/exchangeProp/${id}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getKeysCallback(res.data)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkRewardGetProp: function(num,getPropCallback){
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/turntableConfig/getProp/${num}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.data)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmRewardGetProp: function(num,getPropCallback,errCallback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/platTurntableConfig/getProp/${num}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.data)
			}else{
				errCallback()
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
    sdkVideoAd: function (adCallback,callback) {
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/order/create/android',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {//code：201开启倒计时，202免广告卡
			if(res.code == 200){
				adCallback(res.data)
			}else if(res.code == 201 || res.code == 202){
				callback(res)
				ElMessage({
					message: res.msg,
					plain: true
				})
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
			
		});
    },
	sdkVideoAdKeys: function (adCallback,callback) {
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/turntableConfig/createOrder',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {//code：201开启倒计时
			if(res.code == 200){
				adCallback(res.data)
			}else if(res.code == 201){
				callback(res)
				ElMessage({
					message: res.msg,
					plain: true
				})
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
			
		});
	},
	sdkGmVideoAdKeys: function (adCallback,callback) {
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/platTurntableConfig/createOrder',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {//code：201开启倒计时，202使用免广告卡
			if(res.code == 200){
				adCallback(res.data)
			}else if(res.code == 201){
				callback(res)
				ElMessage({
					message: res.msg,
					plain: true
				})
			}else if(res.code == 202){
				callback(res)
				ElMessage({
					message: res.msg,
					plain: true
				})
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
			
		});
	},
    sdkDialogGmInfo: function(dialogCallback,errCallback){
    	let args = getparams(true)
    	let sign = getSign(args)
    	delete args.ScretKeys
    	request({
    		url: '/gmToolConfig/getInfo',
    		headers: {
    		  isIaaApi: true
    		},
    		method: 'post',
    		data: { sign, ...args }
    	}).then(function (res) {
    		if(res.code == 200){
    			dialogCallback(res.data)
    		}else{
    			errCallback(res)
    			ElMessage({
    			    message: res.msg,
    			    type: 'error',
    				plain: true
    			})
    		}
    	})
    },
	sdkGmGetProps: function(id,getPropCallback){
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/gmToolConfig/getPropInfo/${id}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.data)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmFindProps: function(id,param,getPropCallback){
		let args = getparams(true,param)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/gmToolConfig/findProp/${id}`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.data)
			}else{
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmSendProp: function(param,getPropCallback,errCallback){
		let args = getparams(true,param,true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/gmToolConfig/sendProp`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.msg)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmSendPropNum: function(param,getPropCallback,errCallback){
		let args = getparams(true,param,true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/gmToolConfig/findPropNum`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				getPropCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmOpenPlat: function(){//渠道是否开放gm工具页面
		let args = getparams(true,{},true)
		let limitPlats = ['40025']//5.16更，特殊渠道限制游戏不开，其他都开
		let openGames = ['2213','2049','2144','2074','2241','2118','2247','2236','2254','2199','1782','2187']//限制渠道开放游戏//5.16改为限制不开的游戏
		if(args && args.chanleNo){
			if(args.openId == '63947499'){//开启调试模式
				const vConsole = new VConsole();
			}
			if(limitPlats.includes(args.chanleNo)){//不开
				if(openGames.includes(args.gameId)){//渠道开启游戏//5.16改为渠道不开的游戏
					return false
				}else{
					return true
				}
			}else{
				return true
			}
		}else{
			return false
		}
	},
	sdkGetInfos: function(){
		let args = getparams(true,{},true)
		if(args.openId == '64174674' || args.openId == '60339564'){//开启调试模式
			const vConsole = new VConsole();
		}
		return args
	},
	sdkGmSpecialOrder: function(adCallback,callback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/platTurntableConfig/createOrderSpecial`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 202){
				callback(res)
				ElMessage({
					message: '领取成功',
					plain: true
				})
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmLuckyGift: function(sCallback,callback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/iaa/luckyGift/getUrl`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				sCallback(res)
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmLuckyGiftOrder: function(sCallback,callback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/iaa/luckyGift/createOrder`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				sCallback(res)
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmLuckyGiftSpecial: function(sCallback,callback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: `/iaa/luckyGift/createOrderSpecial`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				sCallback(res)
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmSpecialState: function(sCallback,callback){
		let args = getparams(true,{},true)
		let sign = getSign(args)
		delete args.ScretKeys
		if(!args.roleId){
			console.log('角色信息异常')
			return false
		}
		request({
			url: `/platTurntableConfig/getSpecialStateInfo`,
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				sCallback(res)
			}else{
				callback(res)
				ElMessage({
					message: res.msg,
					type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmWelfareInfo: function(dialogCallback,errCallback){
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/iaaGmToolConfig/getInfo',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				dialogCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	},
	sdkGmWelfareProp: function(dialogCallback,errCallback){
		let args = getparams(true)
		let sign = getSign(args)
		delete args.ScretKeys
		request({
			url: '/iaaGmToolConfig/sendProp',
			headers: {
			  isIaaApi: true
			},
			method: 'post',
			data: { sign, ...args }
		}).then(function (res) {
			if(res.code == 200){
				dialogCallback(res.data)
			}else{
				errCallback(res)
				ElMessage({
				    message: res.msg,
				    type: 'error',
					plain: true
				})
			}
		})
	}
  };
	function getparams(isExtend=false,param={},isChannel=false){
		let obj = {};
		if(!useIaaStore().secretParams){
			return obj
		}
		let params = decryptByDES(useIaaStore().secretParams)
		let args = JSON.parse(params);
		// console.log(params)
		if(param.length != 0){
			args = Object.assign(args,param)
		}
		if(isChannel){
			obj.chanleNo = JSON.parse(args.extendParams).channel_id || ''
		}
		for(let [key, value] of Object.entries(args)){
		  if (typeof value !== 'undefined' && value !== "") {
			  if(!isExtend){
				  if(key != "extendParams"){
					  obj[key] = value
				  }
			  }else{
				  obj[key] = value
			  }
		  }
		}
		return obj
	}
 function iaaIosPostMsg (obj) {
  	let backReturn = window.webkit.messageHandlers.eventComplete.postMessage(JSON.stringify(obj));
  	return backReturn;
  }
 function iaaAndroidPostMsg (obj) {
  	let backReturn = sdkcnadsapi.callAndroidFunction(JSON.stringify(obj));
  	return backReturn;
  }	

  function getSign(paramData) {
	var formArr = [];
	 for(let [i, value] of Object.entries(paramData)){
	  if (typeof value !== 'undefined' && i != "ScretKeys" && value !== "") {
		var str = "" + i + "=" + value + "";
		formArr.push(str);
	  }
	}
	var signStr = formArr.sort().join("&") + "&" + paramData.ScretKeys;
	console.log('加密前====',signStr)
	let sign = CryptoJS.MD5(signStr).toString();
	console.log('加密后====',sign)
	return sign;
  }

